/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { FancyCheckboxComponent } from './fancy-checkbox/fancy-checkbox.component';

import { DropdownMenuComponent } from './dropdown-menu/dropdown-menu.component';
import {
	NavBarComponent,
	SupportMenuComponent,
	NavBarAccountComponent,
	NavBarDashboardComponent,
	NavBarPlanComponent,
} from './nav-bar/';
import { CloseWhenIgnoredDirective } from './close-when-ignored/close-when-ignored.directive';
import { AccessCodeQuickJoinComponent } from './access-code-quick-join/access-code-quick-join.component';
import { ErrorPinComponent } from './error-pin/error-pin.component';
import { RoleChangerComponent } from './nav-bar/role-changer/role-changer.component';
import { DraggableContainerComponent } from './draggable-container/draggable-container.component';
import { ResizableContainerComponent } from './resizable-container/resizable-container.component';
import { MultiRoleSelectComponent } from './multi-role-select/multi-role-select.component';
import { ConstraintPendingAcceptanceComponent } from './constraint-pending-acceptance/constraint-pending-acceptance.component';
import { IconCheckboxComponent } from './icon-checkbox/icon-checkbox.component';
import { PlanPositioningDirective } from './plan-positioning/plan-positioning.directive';
import { FocusOnShowDirective } from './focus-on-show/focus-on-show.directive';
import { DisallowInputDirective } from './disallow-input/disallow-input.directive';
import { PulseAnimationDirective } from './pulse-animation/pulse-animation.directive';
import { ShakeAnimationDirective } from './shake-animation/shake-animation.directive';
import { MeetingPopup } from './meeting-popup/meeting-popup.component';
import { SafeUrlPipe } from '../pipes/safe-url-pipe';
import { AbsPipe } from '../pipes/absolute-value-pipe';
import { PositionTrackerDirective } from './position-tracker/position-tracker.directive';
import { ContainerLayerManager } from './base-container/ContainerLayerManager';
import { AutoHideLabelComponent } from './auto-hide-label/auto-hide-label.component';
import { SharedUtilityComponentsModule } from './shared-utility-components.module';
import { AllowedLinksEditorComponent } from './allowed-links/allowed-links-editor/allowed-links-editor.component';
import { AllowedLinksStarterComponent } from './allowed-links/allowed-links-starter.component';
import { HoverOverContentEditorComponent } from './hover-over-content/hover-over-content-editor/hover-over-content-editor.component';
import { HoverOverContentStarterComponent } from './hover-over-content/hover-over-content-starter.component';
import { MaterialModule } from '../material/material-module';
import { SharedUIMaterialModule } from 'src/app/shared/ui/material/shared-ui-material.module';
import { PresentationModule } from '../presentation-components/presentation.module';
import { HoverOverContainerComponent } from './hover-over-container/hover-over-container.component';
import { QuickSearchComponent } from '../../modules/plan-tickets-filter/components/quick-search/quick-search.component';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';

@NgModule({
	imports: [
		ReactiveFormsModule,
		CommonModule,
		FormsModule,
		SharedUtilityComponentsModule,
		MaterialModule, // Might not need thi import after AllowedLinks stuff moved
		SharedUIMaterialModule,
		PresentationModule,
		QuickSearchComponent,
		DialogReusableModule,
	],
	declarations: [
		CloseWhenIgnoredDirective,
		FancyCheckboxComponent,
		DropdownMenuComponent,
		NavBarComponent,
		SupportMenuComponent,
		NavBarAccountComponent,
		NavBarDashboardComponent,
		NavBarPlanComponent,
		AccessCodeQuickJoinComponent,
		ErrorPinComponent,
		RoleChangerComponent,
		MultiRoleSelectComponent,
		ConstraintPendingAcceptanceComponent,
		IconCheckboxComponent,
		DraggableContainerComponent,
		ResizableContainerComponent,
		HoverOverContainerComponent,
		PlanPositioningDirective,
		FocusOnShowDirective,
		DisallowInputDirective,
		PulseAnimationDirective,
		ShakeAnimationDirective,
		MeetingPopup,
		SafeUrlPipe,
		AbsPipe,
		DraggableContainerComponent,
		PositionTrackerDirective,
		AutoHideLabelComponent,
		AllowedLinksEditorComponent,
		AllowedLinksStarterComponent,
		HoverOverContentEditorComponent,
		HoverOverContentStarterComponent,
	],
	exports: [
		CloseWhenIgnoredDirective,
		FancyCheckboxComponent,
		DropdownMenuComponent,
		NavBarComponent,
		SupportMenuComponent,
		NavBarAccountComponent,
		NavBarDashboardComponent,
		NavBarPlanComponent,
		AccessCodeQuickJoinComponent,
		ErrorPinComponent,
		RoleChangerComponent,
		MultiRoleSelectComponent,
		ConstraintPendingAcceptanceComponent,
		IconCheckboxComponent,
		DraggableContainerComponent,
		ResizableContainerComponent,
		HoverOverContainerComponent,
		PlanPositioningDirective,
		FocusOnShowDirective,
		DisallowInputDirective,
		PulseAnimationDirective,
		ShakeAnimationDirective,
		MeetingPopup,
		SafeUrlPipe,
		AbsPipe,
		DraggableContainerComponent,
		PositionTrackerDirective,
		AutoHideLabelComponent,
		AllowedLinksEditorComponent, // Will likely have to move this when side panel gets rebuilt
		AllowedLinksStarterComponent, // Will likely have to move this when side panel gets rebuilt
		HoverOverContentEditorComponent, // Will likely have to move this when side panel gets rebuilt
		HoverOverContentStarterComponent, // Will likely have to move this when side panel gets rebuilt
	],
	providers: [ContainerLayerManager],
})
export class UtilityComponentsModule {}
